import ASSETS from "src/config/assets";
export default function AppImage({ code, src, onClick = () => {}, className, ...props }) {
  if (!(src || code)) return <></>;
  return <img {...(src && { src })} {...(!src && code && { src: ASSETS[code] })} onClick={onClick} className={`object-contain ${className}`} {...props} />;
}
